<template>
    <div class="billing-details">
        <div class="section-row">
            <div class="section-row-header">
                {{ resources.billingAddressHeader }}
            </div>

            <div v-if="isHomeDelivery" class="vue-form-row">
                <vue-input :element="sameAsDeliveryAddress"
                    @blur="updateFieldValue(sameAsDeliveryAddress.id, $event.target.value)"
                />
            </div>
        </div>

        <template v-if="!isHomeDelivery || (!sameAsDeliveryAddress.state.value && (!hasSavedAddress || noSavedBillingAddresUS))">
            <div class="section-row">
                <div v-for="(row, index) in namesRows" :key="index"
                    :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                    <vue-input v-for="element in row" :key="element.id"
                        :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
                </div>
            </div>

            <div class="section-row" v-if="addressSearchRow && addressFieldsHidden">
                <div class="vue-form-row">
                    <vue-input :element="addressSearchRow[0]" />
                </div>
            </div>

            <div v-if="hiddenRows && addressFieldsHidden" class="reveal-hidden" @click="addressFieldsHidden = false; enableEditBilling = true">
                {{ resources.enterAddressCTA }}
            </div>

            <div v-if="hiddenRows && !addressFieldsHidden" class="section-row">
                <div v-for="(row, index) in hiddenRows" :key="index"
                    :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                    <vue-input v-for="element in row" :key="element.id"
                        :element="element" @blur="updateFieldValue(element.id, $event.target.value)"/>
                </div>
            </div>
        </template>

        <address-picker
            v-if="!sameAsDeliveryAddress.state.value && hasSavedAddress && !noSavedBillingAddresUS"
            :header-label="resources.billingAddressPickerHeader"
            :selected-address-id="selectedAddresses.selectedBillingAddressId"
            :selection-mutation="updateAddressMutation"
            :type="'billing'"
        />

        <div class="section-row" v-if="sameAsDeliveryAddress.state.value && hasSavedAddress">
            <address-summary :address-id="selectedAddresses.selectedShippingAddressId" :address-format="addressBookResources.addressFormat"/>
        </div>

        <div class="section-row">
            <div v-for="(row, index) in vatRows" :key="index"
                :class="['vue-form-row', { 'has-multiple-elements': row.length > 1 }]">
                <vue-input
                    v-for="element in row"
                    v-if="element.id !=='saveAddress' || !sameAsDeliveryAddress.state.value && !hasSavedAddress"
                    :key="element.id"
                    :element="element"
                    @blur="updateFieldValue(element.id, $event.target.value)"
                />
            </div>
        </div>

        <slot />
    </div>
</template>
<script src="./billing-details.js"/>
